/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import { DocumentVoModel } from './document-vo.model';
import { DelEmployeeVoModel } from '@well/delivery-libs/employee/domain';

export class DocumentTransferDtoModel extends JSONable {
    uuid: string | undefined
    documentTransferDate: string | undefined | null
    employeeVO: DelEmployeeVoModel | undefined | null
    documentVO: DocumentVoModel | undefined
}
